import { createAction, props } from '@ngrx/store';

import {
  Application,
  ApplicationGroup,
  SingleApplicationDatastream,
  Datastream,
  ApplicationGroupWithApplicationDatastreams,
} from '../shared/models';

export const init = createAction(
  '[App] Init',
  props<{ entityExternalId: string; system: string }>(),
);

export const initialized = createAction('[App] Initialized');

export const setApplications = createAction(
  '[App] Set applications',
  props<{ applications: Application[] }>(),
);

export const setApplicationGroups = createAction(
  '[App] Set application groups',
  props<{ applicationGroups: ApplicationGroup[] }>(),
);

export const setDatastreams = createAction(
  '[App] Set data streams',
  props<{ datastreams: Datastream[] }>(),
);

export const setApplicationDatastreams = createAction(
  '[App] Set application data streams',
  props<{ applicationDatastreams: SingleApplicationDatastream[] }>(),
);

export const setGroupsDatastreams = createAction(
  '[App] Set groups data streams',
  props<{ groupIds: number[] }>(),
);

export const setGroupDatastreams = createAction(
  '[App] Set group data streams',
  props<{ groupId: number }>(),
);

export const selectApplicationGroups = createAction('[App] Select application groups');

export const setApplicationDatastream = createAction(
  '[App] Set application data stream',
  props<{ applicationKey: string; dataStreamKeys: string[]; oldDataStreamKeys?: string[] }>(),
);

export const updateApplicationDatastream = createAction(
  '[App] Update application data stream',
  props<{ applicationKey: string; dataStreamKeys: string[]; oldDataStreamKeys?: string[] }>(),
);

export const deleteApplicationDatastream = createAction(
  '[App] Delete application data stream',
  props<{ applicationKey: string; dataStreamKeys: string[]; oldDataStreamKeys?: string[] }>(),
);

export const deleteGroupDatastreams = createAction(
  '[App] Delete group data streams',
  props<{ group: ApplicationGroupWithApplicationDatastreams }>(),
);
